import { render, staticRenderFns } from "./ECMInfoTable.vue?vue&type=template&id=6390f168&scoped=true"
import script from "./ECMInfoTable.vue?vue&type=script&lang=js"
export * from "./ECMInfoTable.vue?vue&type=script&lang=js"
import style0 from "./ECMInfoTable.vue?vue&type=style&index=0&id=6390f168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390f168",
  null
  
)

export default component.exports